import { Box, SxProps, Theme } from "@mui/material";
import React from "react";

interface Props {
  src: string;
  style: SxProps<Theme>;
  alt?: string;
}

const Image: React.FC<Props> = (props) => {
  const { src, style, alt } = props;
  return <Box component={"img"} src={src} sx={style} alt={alt} />;
};

export default Image;
